import { UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { endPointUrls } from 'core/constants/endPointUrls';
import toastHandler from 'core/helpers/toast/toast';
import useMutationHook from 'core/hooks/masterQuery/useMutationHook';
import api from 'core/services/fetch-api/useApi';
import { setApiCatcherFormErrors } from 'core/store/slice/mainInfo/mainInfoSlice';
import { useDispatch } from 'react-redux';

export const useAdminSettingsUpdateQuery = (callBack?: () => void) => {
	const dispatch = useDispatch();
	const queryClient = useQueryClient();

	return useMutationHook(
		[endPointUrls.ADMIN_SETTINGS],
		(data: any) => api.patch(endPointUrls.ADMIN_SETTINGS, data),
		{
			onSuccess: (res) => {
				const response = res as AxiosResponse;

				if (response?.status === 200) {
					queryClient.invalidateQueries([endPointUrls.ADMIN_SETTINGS]);
					toastHandler('success', response?.data.message);
					dispatch(setApiCatcherFormErrors([]));
					callBack?.();
				}
			},
		}
	) as UseMutationResult;
};
